import React from 'react';
import {connect} from 'react-redux';
import {getNumbersByType} from '../../changePhoneNumberSlice';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';

const NewNumberRefreshButton = (props) => {
  const selectedType = props.changePhoneNumber.newNumbersData.find((numberType) => numberType.selected);
  function handleRefresh() {
    if (
      selectedType &&
      selectedType.requestCounter < props.changePhoneNumber.maxRequestCount &&
      !props.changePhoneNumber.newNumbersDataLoading
    )
      props.getNumbersByType(selectedType.code);
  }
  return (
    <div className={`new-number-refresh-button-container ${props.disabled ? 'disabled' : ''}`}>
      <div className={`select_new-number-refresh-button ${!props.disabled && selectedType.requestCounter == 3 ? 'disabled' : ''}`}>
        <BtnWhiteBlackBorderBigSize
          svgImage={`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.05844 16.6121C5.21094 16.7243 5.40481 16.7644 5.58969 16.7234C5.77454 16.6823 5.93344
                  16.5635 6.02426 16.3972L7.82504 13.0984C7.99878 12.78 7.8815 12.3804 7.56332 12.2068C7.28504 12.0551 6.94496 12.126 6.74789 12.3591L6.6727
                  12.4695L5.66391 14.322C4.43858 11.0181 5.9925 7.29405 9.25668 5.87086C11.0999 5.06732 13.1072 5.16303 14.7918 5.96657C15.1189 6.12242 15.5107
                  5.98337 15.6668 5.65602C15.8229 5.32864 15.6851 4.93621 15.3582 4.78004C13.3453 3.81979 10.94 3.70471 8.73325 4.66676C4.94 6.3207 3.07656
                  10.5692 4.31137 14.4314L2.81137 13.3279L2.69711 13.2605C2.41986 13.1325 2.08151 13.2128 1.8934 13.4685C1.70548 13.7243 1.7296 14.0711 1.93442
                   14.2976L2.03305 14.3865L5.05844 16.6121ZM18.9527 7.30757C18.8004 7.19564 18.607 7.15448 18.4224 7.19526C18.2374 7.2364 18.0777 7.35602
                   17.9868 7.52241L16.1363 10.913C15.9625 11.2314 16.0798 11.631 16.398 11.8046C16.716 11.978 17.1137 11.8609 17.2876 11.5429L18.3032
                   9.68062C19.5282 12.9845 17.9746 16.7087 14.7105 18.1318C12.8673 18.9353 10.8599 18.8386 9.17532 18.0351C8.84844 17.8794 8.45658 18.0186
                    8.30032 18.3457C8.14423 18.673 8.28217 19.0654 8.60891 19.2216C10.6218 20.1819 13.0271 20.297 15.2339 19.3349C19.0784 17.6585 20.9378
                     13.3183 19.6011 9.41499L21.2847 10.6533L21.399 10.7216C21.6762 10.8497 22.0155 10.7694 22.2036 10.5136C22.4181 10.2215 22.3546 9.81041
                     22.063 9.59565L18.9527 7.30757Z" fill="var(--theme-primary, #810EA9)"/>
                </svg>`}
          text={'למספרים אחרים'}
          onclick={() => handleRefresh()}
          disabled={props.disabled}
        />
      </div>
      <div className='s-title fw-600'>
        <span className={`${!props.disabled && selectedType.requestCounter == 3 ? 'error' : ''}`}>ניתן לרענן את המספרים עד 3 פעמים</span>
        <br />
        <span>אין אפשרות לחזור למספרים הקודמים</span>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  changePhoneNumber: state.changePhoneNumber,
});

const mapDispatchToProps = {
  getNumbersByType,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewNumberRefreshButton);
